import PropTypes from 'prop-types'
import { Element } from '../html/element'
import { SelectPage } from './SelectPage'
import { SelectPageSize } from './SelectPageSize'
import './i18n'

export const Pagination = ({
  page,
  pageSize,
  total,
  setPageSize,
  setPage,
  className,
  pageSizeOptions,
  isShowPageSize,
  isShowPage,
  isShowLastButton,
  zIndex,
  scrollId,
}) => {
  return (
    <Element
      className={[
        'dFlex alignItemsCenter justifyContentBetween',
        className,
      ].join(' ')}
      style={{ color: '#3A414B' }}
    >
      {isShowPageSize && (
        <SelectPageSize
          page={page}
          pageSize={pageSize}
          total={total}
          setPageSize={setPageSize}
          pageSizeOptions={pageSizeOptions}
          zIndex={zIndex}
          scrollId={scrollId}
        />
      )}
      {isShowPage && (
        <SelectPage
          page={page}
          pageSize={pageSize}
          total={total}
          setPage={setPage}
          isShowLastButton={isShowLastButton}
        />
      )}
    </Element>
  )
}

Pagination.propTypes = {
  page: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
  setPageSize: PropTypes.func,
  setPage: PropTypes.func,
  pageSizeOptions: PropTypes.array,
  className: PropTypes.string,
  isShowPage: PropTypes.bool,
  isShowPageSize: PropTypes.bool,
  isShowLastButton: PropTypes.bool,
}

Pagination.defaultProps = {
  page: 1,
  pageSize: 20,
  total: 0,
  setPageSize: () => {},
  setPage: () => {},
  className: '',
  isShowPage: true,
  isShowPageSize: true,
  isShowLastButton: true,
}
